module.exports = "/_next/static/images/349fde9daa05353ffb40d6cb2b8101ba-qr-to-app-v2.svg";